<template>
<div class="withdraw">
  <withdraw-card
    :withdraw-pay-info="bankCardInfo"
  ></withdraw-card>
  <withdraw-card
    :withdraw-pay-info="usdtCardInfo"
  ></withdraw-card>
  <withdraw-card
    :withdraw-pay-info="otcCardInfo"
  ></withdraw-card>
</div>
</template>

<script>
// 出金
import bankIconUrl from '../../../../assets/images/founds/bankTw.png';
import usdtIconUrl from '../../../../assets/images/founds/usdtIcon.png';
import otcIconUrl from '../../../../assets/images/founds/otcIconNew.png';
import { getBankInfo } from '@/api/userCenter'
import withdrawCard from "@/components/withdraw/withdrawCard";
import { mapGetters } from 'vuex';
export default {
  name: "index",
  components:{
    withdrawCard,
  },
  data() {
    return {
      withdrawList: [],
      bankInfo: {
        examineStatus: '',
        payDetailMap:{
          bankAccount: "",
          bankName: "",
          bankStatus: 0,
          firstName: "",
          lastName: "",
          swiftCode: "",
        },
        maximumLimit: 0,
        minimumLimit: 0,
      },
      usdtInfo:{
        payDetailMap:{
          address: "",
          qrPic: "",
        },
        maximumLimit: 0,
        minimumLimit: 0
      },
      otcInfo:{
        payDetailMap:{
          address: "",
          qrPic: "",
        },
        maximumLimit: 0,
        minimumLimit: 0
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    bankCardInfo(){
      return {
        payTypeId: 4,
        channelName: this.$t('Bank_card'),
        logoUrl: bankIconUrl,
        descs: [
          `1.${this.$t('User.limit')}$${this.bankInfo.minimumLimit}~$${this.bankMaximunLimit}。`,
          this.$t('withdrawBankCardTipsSecondLine'),
          '3.' + this.$t('withdrawBankCardTipsThirdlyLine'),
        ]
      }
    },
    bankMaximunLimit(){
      return this.bankInfo.maximumLimt || '∞';
    },
    usdtCardInfo(){
      return {
        payTypeId: 5,
        channelName: 'USDT',
        logoUrl: usdtIconUrl,
        descs: [
          `1.${this.$t('User.limit')}$${this.usdtMinimumLimit}~$${this.usdtMaximumLimit}。`,
          this.$t('withdrawUsdtTipsSecondLine'),
          '3.' + this.$t('withdrawBankCardTipsThirdlyLine'),
        ]
      }
    },
    usdtMinimumLimit(){
      return this.usdtInfo.minimumLimit
    },
    usdtMaximumLimit(){
      return this.usdtInfo.maximumLimt || '∞';
    },
    otcCardInfo(){
      return {
        payTypeId: 6,
        channelName: this.$t('withdraw365'),
        logoUrl: otcIconUrl,
        descs: [
          `1.${this.$t('User.limit')}$${this.otcMinimumLimit}~$${this.otcMaximumLimit}。`,
          '2.' + this.$t('withdrawOtcTipsSecondLine'),
          '3.' + this.$t('withdrawOtcTipThirdlyLine'),
          '4.' + this.$t('withdrawBankCardTipsThirdlyLine'),
        ]
      }
    },
    otcMinimumLimit(){
      return this.otcInfo.minimumLimit;
    },
    otcMaximumLimit(){
      return this.otcInfo.maximumLimt || '∞';
    }
  },
  created(){
    this.getWithdrawList();
  },
  methods: {
    getWithdrawList(){
      getBankInfo({
        custId: this.userInfo.id,
        type: 1,
      }).then((res) => {
        this.withdrawList = res.data;
        for (let i = 0; i < res.data.length; i++) {
          if(res.data[i].payTypeId == 4){
            this.bankInfo = res.data[i];
          }
          if(res.data[i].payTypeId == 5){
            this.usdtInfo = res.data[i];
          }
          if(res.data[i].payTypeId == 6){
            this.otcInfo = res.data[i];
          }
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
